<template>
  <div v-if="!cookieBannerSeen" class="popup" ref="popup">
    <div class="popup-content" @click.stop="">
      <h2 class="popup-title">Cookies</h2>
      <p class="popup-text">Disable non-essential cookies?</p>
      <button @click="closePopup" class="btn popup-yes">Yes</button>
      <button @click="closePopup" class="btn popup-no">No</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cookieBannerSeen: false,
    };
  },
  methods: {
    closePopup() {
      this.cookieBannerSeen = true;
      this.$emit("close-popup");
    },
    handleDocumentClick(event) {
      const popupElement = this.$refs.popup;
      if (popupElement && !popupElement.contains(event.target)) {
        this.closePopup();
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
    const bannerSeen = sessionStorage.getItem("cookieBannerSeen");
    if (bannerSeen) {
      this.cookieBannerSeen = true;
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fade-in 0.5s ease;
}

.popup-content {
  background: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
  animation: slide-up 0.5s ease;
}

.popup-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.popup-text {
  font-size: 16px;
  margin-bottom: 30px;
}

.popup-btn.popup-yes:hover {
  background-color: #2980b9;
}

.popup-yes {
  margin-right: 10px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slide-up {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}
</style>
